import { memo } from 'react';

import { usePrivateTranscriptEditingTaskEvent } from '~/components/AssetModalV2/Content/Panel/Transcript/hooks/usePrivateTranscriptEditingTaskEvent';

export const PrivateTranscriptEditingTasksListener = memo(() => {
  usePrivateTranscriptEditingTaskEvent();

  return null;
});

PrivateTranscriptEditingTasksListener.displayName = 'PrivateTranscriptEditingTasksListener';
